import axios from "axios/index";
import * as types from "../store/mutation-types";
import store from '~/store'

export default {
    async getBuildings (cb) {
        const params = {}

        const {data} = await axios.get('/api/building', params)

        cb(data.data, data.meta.lastChanged)
    },

    async getBuildingDetail (buildingId, cb) {
        const params = {}

        const {data} = await axios.get('/api/building/'+buildingId, params)

        cb(data.data, data.users)
    },

    async deleteBuilding (buildingId, cb) {
        const params = {}

        await axios.delete('/api/building/'+buildingId, params)

        cb()
    },

    async updateBuilding (buildingId, form) {
        const {data} = await form.patch('/api/building/'+buildingId)

        if (form.successful) {
            store.dispatch('building/updateBuilding', data)
        }
        return form.successful;
    },

    async createBuilding (form) {
        await form.post('/api/building')

        return form.successful
    },


    async revokeAccess(buildingAccessId, cb) {
        const params = {}

        const {data} = await axios.delete('/api/buildingaccess/'+buildingAccessId, params)

        cb(data.data, data.users)
    },

    async updateAccess(buildingAccessId, level, cb) {
        const params = {
            level: level
        }

        const {data} = await axios.patch('/api/buildingaccess/'+buildingAccessId, params)

        cb(data.data, data.users)
    },

    async grantAccess(buildingId, userId, level, cb) {
        const params = {
            building_id: buildingId,
            user_id: userId,
            level: level
        }

        const {data} = await axios.post('/api/buildingaccess', params)

        cb(data.data, data.users)
    }


}


// WEBPACK FOOTER //
// ./resources/assets/js/api/buildings.js